import React, { PureComponent } from 'react';
import { ISession } from 'types';
import moment from 'moment';
// Components
import Card from 'ui/card';
import MapImage from '../map/map-image';
import SessionStats from './session-stats';
import { UserName, UserPhoto } from 'components/user';
import { Link } from 'react-router-dom';
import Button from 'ui/button';
import { ICON_COMMENT, ICON_MORE } from 'icons';
import Popover from 'ui/popover';
import { removeSession, reRunConvert } from 'data/session';
import { Loader } from 'ui/loader';
const EMPTY_OBJECT = {};
interface SessionItemProps {
  session: ISession;
}
export default class SessionItem extends PureComponent<SessionItemProps> {
  get data() {
    return this.props.session.data || EMPTY_OBJECT;
  }
  get gps() {
    return this.data.gps;
  }

  state = {
    menu: false
  };

  handleMenuClose = () => {
    this.setState({ menu: false });
  };

  handleMenuOpen = (e: MouseEvent) => {
    e.stopPropagation();
    this.setState({ menu: true, anchorEl: e.currentTarget });
  };

  handleDelete = () => {
    this.setState({ menu: false });
    removeSession(this.props.session.key);
  };

  handleRestart = e => {
    e.stopPropagation();
    reRunConvert(this.props.session.key);
    this.setState({ menu: false });
  };

  render() {
    const { session, className, style, onClick } = this.props;
    const { menu, anchorEl } = this.state;
    return (
      <Card className={className + ' column'} style={style} onClick={onClick}>
        <div className="row v-center tiny-padding">
          <UserPhoto uid={session.creator} />
          <div className="column tiny-margin">
            <UserName className="primary-text" uid={session.creator} />
            <small className="fade-text">Created {moment(session.created).fromNow()}</small>
          </div>
          <div className="flex" />
          <Button className="tiny-margin" icon={ICON_COMMENT} />
          <Button className="tiny-margin" icon={ICON_MORE} onClick={this.handleMenuOpen} />
        </div>
        <Link to={`/session/${session.key}`}>
          <h2 className="tiny-margin">{session.name || 'Untitled session'}</h2>
        </Link>
        <div className="row">
          <SessionStats session={session} />
        </div>
        {session.convertFile && !session.converted ? (
          <div className="flex row v-center h-center">
            {(session.runConvert || session.created) < Date.now() - 1000 * 60 * 60 ? (
              <h3 className="text-error">Seems like somthing went wrong</h3>
            ) : (
              <Loader message="Converting session file" />
            )}
          </div>
        ) : (
          <MapImage className="sub-card flex" image={session.mapImage} point={this.gps} />
        )}

        <Popover
          open={menu}
          anchorEl={anchorEl}
          onRequestClose={this.handleMenuClose}
          className="column"
          anchorOrigin={['right', 'top']}
          targetOrigin={['right', 'top']}
        >
          <Button flat="Restart conversion" onClick={this.handleRestart} />
          <Button flat="Delete session" onClick={this.handleDelete} />
        </Popover>
      </Card>
    );
  }
}
